"use client";

import styles from "@/styles/cart/goods-select-item.module.scss";
import { Checkbox } from "react-vant";
import { DeleteO } from "@react-vant/icons";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { getCompressedImageUrl } from "@/utils/utils";
import { cartProductType } from "@/types/cartProduct";

interface CartGoodsSelectItemProps {
  product: cartProductType;
  loading?: boolean;
  onSelect?: (record: cartProductType, selected: boolean) => void;
  onDelete?: (record: cartProductType) => void;
  onQtyChange?: (record: cartProductType, quantity: number) => void;
  onExpressChange?: (record: cartProductType, upgradeExpress: boolean) => void;
}

export default function CartGoodsSelectItem(props: CartGoodsSelectItemProps) {
  const [quantity, setQuantity] = useState(props.product.quantity || 1);
  const [hasChooseUpgradeExpress, setHasChooseUpgradeExpress] = useState(
    props.product.upgradeExpress === 1 || false
  );

  const handleQuantityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newQuantity = parseInt(e.target.value, 10);
    setQuantity(newQuantity);
    if (newQuantity === 0 && props.onDelete) {
      props.onDelete(props.product);
    } else if (props.onQtyChange) {
      props.onQtyChange(props.product, newQuantity);
    }
  };

  return (
    <div className={styles["comp-goods-select-item"]}>
      <div
        className={`${styles["goods-info"]} ${
          !props.product.isAvailable ? styles["disabled"] : ""
        }`}
      >
        <Checkbox
          className={styles["goods-checkbox"]}
          checked={
            props.product.appSelectStatus && props.product.isAvailable
              ? true
              : false
          }
          disabled={!props.product.isAvailable ? true : false}
          onChange={() => {
            if (props.onSelect) {
              props.onSelect(props.product, !props.product.appSelectStatus);
            }
          }}
        />

        <Link href={props.product.url}>
          <div className={styles["goods-img-box"]}>
            <Image
              className={`${styles["goods-img"]} ${
                !props.product.isAvailable ? styles["goods-img-disabled"] : ""
              }`}
              src={getCompressedImageUrl(props.product.defaultFullUrl, 254)}
              alt={props.product.productName}
              width={127}
              height={127}
            />
            {!props.product.isAvailable ? (
              <div className={styles["goods-disabled-text"]}>Unavailable</div>
            ) : null}
          </div>
        </Link>

        <div className={styles["goods-info-text"]}>
          <div className={styles["name"]}>
            <Link href={props.product.url}>{props.product.productName}</Link>
          </div>
          <div className={styles["postage"]}>
            Postage:&nbsp;
            {props.loading ? (
              <>loading</>
            ) : props.product.savePostage > 0 ? (
              <>
                <div>
                  <span className={styles["postage-price"]}>
                    ${props.product.postage.toFixed(2)}
                  </span>
                  <span className={styles["postage-cross-price"]}>
                    ${props.product.normalPostage.toFixed(2)}
                  </span>
                </div>
              </>
            ) : (
              <span style={{ color: "#D70B17" }}>
                {props.product.isAvailable !== 1
                  ? "-"
                  : props.product.postage == -1
                  ? "Undeliverable"
                  : `$${Number(props.product.postage ?? 0).toFixed(2)}`}
              </span>
            )}
          </div>
          {props.product.savePostage > 0 ? (
            <div className={styles["postage-save-price"]}>
              Save: ${props.product.savePostage.toFixed(2)}
            </div>
          ) : null}
          <div className={styles["unit-price"]}>
            Unit Price:&nbsp;
            <span style={{ color: "#D70B17" }}>${props.product.price}</span>
          </div>
          <div className={styles["goods-operation"]}>
            <select
              value={props.product.isAvailable ? quantity : 1}
              onChange={handleQuantityChange}
              className={styles["quantity-select"]}
              disabled={!props.product.isAvailable ? true : false}
            >
              {[
                <option key={0} value={0}>
                  0 (Delete)
                </option>,
                ...Array.from(
                  {
                    length:
                      props.product.inStock >= 50
                        ? 50
                        : props.product.inStock || 1,
                  },
                  (_, i) => i + 1
                ).map((num) => (
                  <option key={num} value={num}>
                    {num == 50 ? "50(max)" : num}
                  </option>
                )),
              ]}
            </select>

            <DeleteO
              fontSize={24}
              color={"#999999"}
              className={styles["delete-icon"]}
              onClick={() => {
                if (props.onDelete) {
                  props.onDelete(props.product);
                }
              }}
            />
          </div>
          <div className={styles["goods-upgrade-express"]}>
            {props.product.appSelectStatus == 1 &&
            props.product.inStock > 0 &&
            (hasChooseUpgradeExpress || props.product.isShowUpgrade == 1) &&
            props.product.inStock > 0 ? (
              <Checkbox
                checked={props.product.upgradeExpress == 1}
                onChange={(e) => {
                  if (e) setHasChooseUpgradeExpress(true);
                  if (props.onExpressChange) {
                    props.onExpressChange(props.product, e);
                  }
                }}
                shape="square"
                iconSize="14px"
                style={{ marginTop: "10px" }}
              >
                Upgrade to Express Post
              </Checkbox>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
